module.exports = __webpack_public_path__ + "static/assets/f79f6ef06011c5d3bd83befa3e605a78.png";